/** Galactic ring catalogue shared by server-side rules and clients. */
export type RingId = 1 | 2 | 3 | 4 | 5;

export type RingPvpRule =
  | { kind: 'newbieProtection'; maxAttackerLevel: number }
  | { kind: 'levelDifference'; maxDifferenceFraction: number }
  | { kind: 'mostlyFree'; maxDifferenceFraction: number }
  | { kind: 'open' };

export interface RingMeta {
  id: RingId;
  name: string;
  levelRange: [number, number];
  pvp: RingPvpRule;
  accent: 'credit' | 'silicate' | 'isotope' | 'titan' | 'danger';
}

export const RINGS: Record<RingId, RingMeta> = {
  5: { id: 5, name: 'Wiege der Pioniere', levelRange: [1, 15], pvp: { kind: 'newbieProtection', maxAttackerLevel: 15 }, accent: 'credit' },
  4: { id: 4, name: 'Umkämpfter Sektor', levelRange: [16, 25], pvp: { kind: 'levelDifference', maxDifferenceFraction: 0.25 }, accent: 'silicate' },
  3: { id: 3, name: 'Umkämpfter Sektor', levelRange: [26, 35], pvp: { kind: 'levelDifference', maxDifferenceFraction: 0.25 }, accent: 'isotope' },
  2: {
    id: 2,
    name: 'Schwerkraft-Grenze',
    levelRange: [36, 49],
    // Ring 2 is broadly open, but a full-level band prevents trivial farming.
    pvp: { kind: 'mostlyFree', maxDifferenceFraction: 1 },
    accent: 'titan',
  },
  1: { id: 1, name: 'Der Brennpunkt', levelRange: [50, 99], pvp: { kind: 'open' }, accent: 'danger' },
};

export const RING_ORDER: RingId[] = [5, 4, 3, 2, 1];

/** Pure PvP gate; target-ring level-range validation belongs to matchmaking. */
export function canTargetInRing(attackerLevel: number, targetRing: RingId, targetLevel: number): boolean {
  const rule = RINGS[targetRing].pvp;
  if (rule.kind === 'newbieProtection') return attackerLevel <= rule.maxAttackerLevel;
  if (rule.kind === 'levelDifference' || rule.kind === 'mostlyFree') {
    return Math.abs(targetLevel - attackerLevel) <= attackerLevel * rule.maxDifferenceFraction;
  }
  return true;
}
